import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#667085",
      "stroke-dasharray": "2 3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "m15.096 5.168-9.428 9.428"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "15.096",
      cy: "5.404",
      r: "2",
      fill: "#667085",
      transform: "rotate(-45 15.096 5.404)"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "5.904",
      cy: "14.596",
      r: "2",
      fill: "#667085",
      transform: "rotate(-45 5.904 14.596)"
    }, null, -1)
  ])))
}
export default { render: render }